import { TableBody, TableHead, TableRow } from "@mui/material";
import React, { useState } from "react";
import { LocationResponseModel, PartialOrderData, } from "../model/location-response.model";
import { LocationTableColumn } from "../model/location-table-column.model";
import BarekamPagination from "../../../../pages/orders/my/pagination/barekam-pagination";
import NoOrders from "../../../../pages/orders/my/no-orders";
import BarekamText from "../../../../pages/components/text";
import { OrderListContainer, OrderTable, OrderTableCell } from "../../../../pages/orders/my/order-list/styled";
import Message from "../../../../pages/components/message";
import { MessageSections } from "../../../../pages/components/message/message";
import { LocationRow } from "./location-row";
import { OrderModel } from "../../../../pages/shared/models/order/order-item.model";
import { ActionDialog } from "../../../actions/dialogs/action-dialog";
import { useAppSelector } from "../../../../redux/store";
import { useNavigate } from "react-router-dom";
import { LocationModel } from "../../../../pages/shared/models/location.model";

export const fieldNamesByState = [
    'depots', 'sectors', 'corridors', 'racks', 'bins'
]

const LocationsList = ({ locationsData, columns, handlePageChange }: LocationsListProps) => {
    const { orderStateId } = useAppSelector(state => state.ordersReducer);

    const [activeAction, setActiveAction] = useState<string>();
    const [preSelectedLocation, setPreSelectedLocation] = useState<LocationModel>();
    const [activeRowOrders, setActiveRowOrders] = useState([] as OrderModel[]);

    const navigate = useNavigate();

    function handleRowClick(partialOrderData: PartialOrderData): void {
        navigate(`../${partialOrderData.orderId}`);
    }

    async function onLocationActionFunctionClick(location: LocationModel, actionId: string) {
        setActiveRowOrders([]);
        setPreSelectedLocation(location);
        setActiveAction(actionId);
    }

    async function onActionFunctionClick(row: OrderModel, actionId: string) {
        if (row && actionId) {
            setActiveRowOrders([row]);
            setActiveAction(actionId);
        }

        //
        //     if (actionId === InWarehouseActionTypes.PRE_SELECT_LOCATION_AND_ADD_ORDERS) {
        //         setPreSelectedLocation({
        //
        //         } as LocationModel);
        //     } else if (actionId === InWarehouseActionTypes.)
        //     setActiveRowOrders(orders.orders);
        //     setActiveAction(actionId);
        // }
    }

    const CustomersListTableHead = () => {
        return (
            <TableHead>
                <TableRow>
                    {columns.map((column, index) => (
                        <OrderTableCell key={`${index}-${column.variant}`}>
                            <BarekamText variant={'m'} fontWeight={600} align={index === columns.length - 1 ? 'right' : 'left'}>
                                <Message messageKey={column.headerName} sectionId={MessageSections.ORDERS} />
                            </BarekamText>
                        </OrderTableCell>
                    ))}
                </TableRow>
            </TableHead>
        )
    }

    function handleActionDialogClosed() {
        setActiveAction(undefined);
        handlePageChange(null, locationsData.page);
    }

    return (
        <>
            <OrderListContainer>
                {locationsData?.data?.length
                    ? <OrderTable width={'100%'}>
                        <CustomersListTableHead />

                        <TableBody>
                            {locationsData.data.map((depotData, index) => (
                                <LocationRow columns={columns}
                                    location={{ depot: depotData.depot, sector: null, corridor: null, rack: null, bin: null }}
                                    row={depotData}
                                    onAction={onActionFunctionClick}
                                    onLocationRowAction={onLocationActionFunctionClick}
                                    level={0}
                                    clicked={handleRowClick}
                                    index={index}
                                    key={`${index}-${0}`}
                                />
                            ))}
                        </TableBody>
                    </OrderTable>
                    : <NoOrders messageKey={'no_location_found'} />
                }

                {locationsData.totalPages > 0
                    ? <BarekamPagination totalItems={locationsData.totalPages * locationsData.pageSize}
                        pageSize={locationsData.pageSize}
                        currentPage={locationsData.page}
                        onPageChange={handlePageChange} />
                    : <></>
                }
            </OrderListContainer>

            <ActionDialog open={!!activeAction}
                closePopup={() => handleActionDialogClosed()}
                action={activeAction}
                orderStateId={orderStateId}
                location={preSelectedLocation}
                historyDialogProps={activeRowOrders[0]?.orderId ? { category: 'Order', categoryId: activeRowOrders[0].orderId } : undefined}
                predefinedOrders={activeRowOrders} />
        </>
    )
}

interface LocationsListProps {
    columns: LocationTableColumn[],
    locationsData: LocationResponseModel,
    handlePageChange: (event: any, newPage: number) => void
}

export default LocationsList;
